import React, { useEffect, useState } from "react";
import classes from "./DoublesMatchesList.module.css";

const DoublesMatchesList = ({ matches, onToggleMatch, matchesMultipleSelection }) => {


  if (!matches || matches.length === 0) {
    return (
      <div className="d-flex justify-content-center">
        <h4>No matches are available.</h4>
      </div>
    );
  }
  const allMatchesSelected = matches.every((match) => match.isSelected);
  return (
    <div className={`d-flex justify-content-center ${classes["table-container"]}`}>
      <table
        className={`table table-sm table-dark table-responsive scrollbar perfect-scrollbar ${classes["matches-table"]}`}
      >
        <caption>Matches List</caption>
        <thead>
          <tr>
            <th scope="col">
              <input
                type="checkbox"
                checked={allMatchesSelected}
                onChange={() => matchesMultipleSelection(!allMatchesSelected)}
              />
            </th>
            <th scope="col" className="text-nowrap">
              First Team
            </th>
            <th scope="col" className="text-nowrap">
              Second Team
            </th>
            <th scope="col" className="text-nowrap">
              Event
            </th>
            <th scope="col" className="text-nowrap">
              Round
            </th>
            <th scope="col" className="text-nowrap">
              Surface
            </th>
            <th scope="col" className="text-nowrap">
              Winner
            </th>
          </tr>
        </thead>
        <tbody>
          {matches.map((match) => (
            <tr key={match.matchId}>
              <th scope="row">
                <input type="checkbox" checked={match.isSelected} onChange={() => onToggleMatch(match)} />
              </th>
              <td className="text-nowrap">{match.firstTeamName}</td>
              <td className="text-nowrap">{match.secondTeamName}</td>
              <td className="text-nowrap">{match.eventName}</td>
              <td className="text-nowrap">{match.roundName}</td>
              <td className="text-nowrap">{match.surface}</td>
              <td className="text-nowrap">{match.winnerName}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DoublesMatchesList;
